var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemographics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1999 29.7H18.5366L24.1999 34.5543V29.7Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6001 30.3456V35.1998H23.2634L17.6001 30.3456Z",
    fill: "#616161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 34.1H35.2V35.2H27.5V34.1Z",
    fill: "#616161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80029 16.5H15.7228L8.80029 9.57755V16.5Z",
    fill: "#616161"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5001 15.7225V8.80002H9.57764L16.5001 15.7225Z",
    fill: "#616161"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 29.7H35.2V30.8H27.5V29.7Z",
    fill: "#616161"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80029 29.7H14.3003V35.2H8.80029V29.7Z",
    fill: "#616161"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6001 6.60001V37.4H37.4001V6.60001H6.6001ZM18.7001 7.70001H26.4001V8.80001H18.7001V7.70001ZM26.4001 12.1V13.2H25.3001V12.1H26.4001ZM18.7001 9.90001H24.2001V11H18.7001V9.90001ZM18.7001 12.1H24.2001V13.2H18.7001V12.1ZM18.7001 14.3H26.4001V15.4H18.7001V14.3ZM18.7001 16.5H26.4001V17.6H18.7001V16.5ZM7.7001 7.70001H17.6001V17.6H7.7001V7.70001ZM15.4001 36.3H7.7001V28.6H15.4001V36.3ZM25.3001 36.3H16.5001V28.6H25.3001V36.3ZM36.3001 36.3H26.4001V33H36.3001V36.3ZM36.3001 31.9H26.4001V28.6H36.3001V31.9ZM36.3001 27.5H7.7001V18.7H36.3001V27.5ZM36.3001 14.3H34.1001V16.5H27.5001V9.90001H29.7001V7.70001H36.3001V14.3Z",
    fill: "#616161"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7001 11H28.6001V15.4H33.0001V14.3H29.7001V11Z",
    fill: "#616161"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80029 19.8H35.2003V26.4H8.80029V19.8Z",
    fill: "#616161"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8003 8.80002H35.2003V13.2H30.8003V8.80002Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemographics);
export default __webpack_public_path__ + "static/media/Demographics.8f1d5b6cfbc06c9b573ca4e578ab87c7.svg";
export { ForwardRef as ReactComponent };